import React, { useEffect, useState } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useNavigate } from 'react-router-dom';
import CookieSettingsModal from './CookieSettingsModal';

export const WarningModal = props => {
  const { isOpen, onClose, languageData } = props;
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  // ---- Mostrar solo si no se aceptó antes ----
  useEffect(() => {
    const alreadyAccepted = localStorage.getItem('cookiesAccepted');

    if (!alreadyAccepted && isOpen) {
      setShowModal(true);
    }
  }, [isOpen]);

  if (!showModal) return null;

  const handleAcceptAll = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowModal(false);
    onClose();
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowModal(false);
    onClose();
  };

  const handleCustomise = () => {
    setShowSettings(true);
  };

  return (
    <FlexContainer
      className={
        'pos-fixed align-items-center justify-center left0 bottom0 width100'
      }
      style={{
        zIndex: 1000,
      }}
    >
      <FlexContainer
        className={'flex-column bgWhite border-rad10px pad20 width100 margr30'}
        onClick={e => e.stopPropagation()}
      >
        <Label className={'text-18'}>
          {' '}
          <strong>
            {languageData === 'EN'
              ? 'We value your privacy'
              : 'Valoramos tu privacidad'}
          </strong>
        </Label>{' '}
        <Label className={'text-16 margt10 margb10'}>
          {languageData === 'EN'
            ? 'We use cookies to make Popnest work better for you, enhancing performance, personalization, and security. We also share limited information with trusted partners to improve our services. You can manage your cookie settings anytime or learn more in our Privacy Policy.'
            : 'Usamos cookies para que Popnest funcione mejor para ti, mejorando el rendimiento, la personalización y la seguridad. También compartimos información limitada con socios de confianza para mejorar nuestros servicios. Puedes gestionar la configuración de cookies en cualquier momento o obtener más información en nuestra Política de Privacidad.'}
        </Label>
        <FlexContainer className={'flex-column margt10 gap-10 margb150'}>
          <button
            className={
              'bgGradientSignUpPurple border-rad4px borderNone fontWhite padlr10 padtb10 width100 text-16'
            }
            onClick={handleAcceptAll}
          >
            {languageData === 'EN' ? 'Accept All' : 'Aceptar Todas'}
          </button>
          <button
            className={
              'borderPurpleGradient fontPurple400 padlr10 padtb10 width100 text-16'
            }
            onClick={handleCustomise}
          >
            {languageData === 'EN' ? 'Customise' : 'Personalizar'}
          </button>
          <button
            className={
              'borderPurpleGradient fontPurple400 padlr10 padtb10 width100 text-16'
            }
            onClick={handleRejectAll}
          >
            {languageData === 'EN' ? 'Reject All' : 'Rechazar Todas'}
          </button>
          {showSettings && (
            <CookieSettingsModal
              languageData={languageData}
              onClose={() => {
                setShowSettings(false);
                setShowModal(false);
                onClose();
              }}
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default WarningModal;
